import Vue from "vue";
import VueRouter from "vue-router";
import store from "@store";
import { i18n } from "@/plugins/i18n.js";

import viewLaunch from "@/views/main/mv-wd-launch.vue";
import viewWelcome from "@/views/main/welcome.vue";
import viewLogin from "@/views/auth/mv-wd-login.vue";
import viewSignup from "@/views/auth/mv-wd-signup.vue";

import defaultLayout from "@/views/main/wd-mv-layout-vertical-view.vue";
import viewTemplate from "@/views/template/mv-wd-template.vue";
import viewCanvas from "@/views/canvas/mv-wd-canvas.vue";
import viewAccount from "@/views/account/mv-wd-account.vue";
import viewGallary from "@/views/gallary/mv-wd-gallary.vue";
import ChatDoc from "@/views/chatdoc/cd-chat-launch.vue";
import Optimize from "@/views/chatdoc/widgets/home/optimize-content.vue";
import SubscriptionsPage from "@/views/subscriotion/views/subscriptionsPage.vue";
import CheckoutPage from "@/views/subscriotion/views/checkoutPage.vue";
import PaymentSuccessPage from "@/views/subscriotion/views/paymentSuccessPage.vue";
import StripePaymentSuccessPage from "@/views/subscriotion/views/stripePaymentSuccessPage.vue";
import UsageRecords from "@/views/subscriotion/views/usageRecords.vue";


Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/launch" },
  { path: "/launch", name: "launch", component: viewLaunch },
  {
    path: "/welcome",
    name: "welcome",
    component: viewWelcome,
  },
  {
    path: "/login",
    name: "login",
    component: viewLogin,
  },
  {
    path: "/signup",
    name: "signup",
    component: viewSignup,
  },
  {
    path: "/chatdoc",
    component: defaultLayout,
    children: [
      {
        path: "/chat-doc",
        name: i18n.t("main.title_menu_gpt"),
        component: ChatDoc,
        meta: {
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/optimize",
    component: defaultLayout,
    children: [
      {
        path: "/optimize",
        name: i18n.t("main.title_menu_gpt"),
        component: Optimize,
        meta: {
          keepAlive: true,
        },
      },
    ],
  },
  // Template
  {
    path: "/template",
    component: defaultLayout,
    children: [
      {
        path: "/template",
        name: i18n.t("main.title_menu_template"),
        component: viewTemplate,
        meta: {
          keepAlive: true,
        },
      },
    ],
  },
  // Canvas
  {
    path: "/canvas",
    component: defaultLayout,
    children: [
      {
        path: "/canvas",
        name: i18n.t("main.title_menu_canvas"),
        component: viewCanvas,
        meta: {
          keepAlive: true,
        },
      },
    ],
  },
  // Account
  {
    path: "/account",
    component: defaultLayout,
    children: [
      {
        path: "/account",
        name: i18n.t("main.title_menu_account"),
        component: viewAccount,
        meta: {
          keepAlive: true,
        },
      },
    ],
  },
  // Galary
  {
    path: "/gallary",
    component: defaultLayout,
    children: [
      {
        path: "/gallary",
        name: i18n.t("main.title_menu_gallary"),
        component: viewGallary,
        meta: {
          keepAlive: true,
        },
      },
    ],
  },  
  // Subscriptions
  {
    path: "/subscriptions",
    name: "subscriptions",
    component: SubscriptionsPage,
  },  
  {
    path: "/checkout",
    name: "checkout",
    component: CheckoutPage,
  },   
  {
    path: "/usage-records",
    name: "usage-records",
    component: UsageRecords,
  },
  {
    path: "/payment-success",
    name: "payment-success",
    component: PaymentSuccessPage,
  },
  {
    path: "/stripe-payment-success",
    name: "stripe-payment-success",
    component: StripePaymentSuccessPage,
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes,
});

router.beforeEach((to, from, next) => {
  store.set("app/name", to.name);
  next();
});

export default router;
